import {AnyAction} from 'redux';
import {RootState} from '../../../store';
import {call, put, select, takeLatest} from 'redux-saga/effects';
import * as Constants from '../constants/inclusionConstants'
import { IResponseStatus} from '../reducers/inclusionsReducers'
import * as Services from '../services/inclusionService'
import {parseResponse} from '../../../store/saga/responseParser';

function* getInclusionsSummary(action: AnyAction) {
  const getApiKey = (state: RootState) => state.authReducer.token
  
  try {
    const api_key: string = yield select(getApiKey)
    const response: IResponseStatus = yield call( Services.inclusionSummary, api_key, action.patientId)
    yield call(
        parseResponse,
        response,
        Constants.GET_INCLUSIONS_SUMMARY_SUCCESS,
        Constants.GET_INCLUSIONS_SUMMARY_FAILED
    )
    response.data.error ? action.reject(response.data.error) : action.resolve()
    
  } catch (error) {
    yield put({type: Constants.GET_INCLUSIONS_SUMMARY_FAILED, error})
  }
}

function* getInclusions(action: AnyAction) {
  const getApiKey = (state: RootState) => state.authReducer.token
  
  try {
    const api_key: string = yield select(getApiKey)
    const response: IResponseStatus = yield call(Services.inclusions, api_key, action.page, action.limit, action.read, action.patientId)
    yield call(
        parseResponse,
        response,
        Constants.GET_INCLUSIONS_SUCCESS,
        Constants.GET_INCLUSIONS_FAILED
    )
    response.data.error ? action.reject(response.data.error) : action.resolve()
  } catch (error) {
    yield put({type: Constants.GET_INCLUSIONS_FAILED, error })
  }
}

function* getFilePdf(action: AnyAction) {
  const getApiKey = (state: RootState) => state.authReducer.token
  try {
    const api_key: string = yield select(getApiKey)
    const response: IResponseStatus = yield call(
        Services.getFilePdf,
        api_key,
        action.fileId,
    )
    
    yield call(
        parseResponse,
        response,
        Constants.GET_FILE_PDF_SUCCESS,
        Constants.GET_FILE_PDF_FAILED
    )
    response.status === 200 ? action.resolve(response.data) : action.reject(response.data.error)
  } catch (error) {
    yield put({type: Constants.GET_FILE_PDF_FAILED, error})
  }
}

function* updateInclusionMakerReaded(action: AnyAction) {
  const getApiKey = (state: RootState) => state.authReducer.token
  try {
    const api_key: string = yield select(getApiKey)
    const response: IResponseStatus = yield call(
        Services.updateInclusionMakerRead,
        api_key,
        action.implantEnrollmentId,
        action.maker_readed,
    )
    yield call(
        parseResponse,
        response,
        Constants.UPDATE_INCLUSION_MAKER_READED_SUCCESS,
        Constants.UPDATE_INCLUSION_MAKER_READED_FAILED,
    )
    response.status === 200
        ? action.resolve(response.data)
        : action.reject(response.data.error)
  } catch (error) {
    yield put({
      type: Constants.UPDATE_INCLUSION_MAKER_READED_FAILED,
      error,
    })
  }
}
export const inclusionsSaga = [
    takeLatest(Constants.GET_INCLUSIONS_SUMMARY, getInclusionsSummary),
    takeLatest(Constants.GET_INCLUSIONS, getInclusions),
    takeLatest(Constants.GET_FILE_PDF, getFilePdf),
    takeLatest(Constants.UPDATE_INCLUSION_MAKER_READED, updateInclusionMakerReaded)
]
